<template>
  <q-dialog :visible="isVisible" title="产品基础价格调整记录" width="80%" :innerScroll="false" :showFooter="false" @close="onCancel">
    <div class="dialog-content">
      <el-form class="dialog-el-form">
        <el-form-item label="产品编码：">
          <div>{{ row.productCode }}</div>
        </el-form-item>
        <el-form-item label="产品名称：">
          <div>{{ row.productName }}</div>
        </el-form-item>
      </el-form>
      <el-table class="table-wrapper" :data="tableData.records" :header-cell-style="{ backgroundColor: '#F4F8FB' }" border :max-height="300" v-loading="loading">
        <el-table-column :show-overflow-tooltip="true" prop="retailPrice" label="零售指导价"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="reason" label="调整原因"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createdBy" label="更新人"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createdDate" label="更新时间"></el-table-column>
      </el-table>
      <div class="footerBox">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[10, 30]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
        ></el-pagination>
      </div>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'AdjustmentRecordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    init() {
      this.loading = true;
      const param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          productCode: this.row.productCode,
        },
      };
      this.$q.product
        .recordListPage({ data: JSON.stringify(param) })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>
.dialog-content
  padding 0 15px 15px

.footerBox
  text-align right
  padding-top 10px

.table-wrapper
  margin 10px 0

.dialog-el-form >>> .el-form-item
  margin-bottom 0
</style>
